import axios from "axios";

const SERVICES_URL = process.env.SERVICES_URL;
const API_URL = `${SERVICES_URL}/api/v1/diamond`;

export const cutVideoForPlay = async (appealId: number, cuts: VideoCutType[]): Promise<Video[]> => {
  const response = await axios.post(`${API_URL}/${appealId}`, cuts);
  return response.data;
};
